// extracted by mini-css-extract-plugin
export default {"openChatBtn":"profile-2-chat-btn_openChatBtn__nEv3k"};